import { Component, Input, OnInit, AfterViewInit, ViewChild, Inject } from '@angular/core'
import { I18NService } from '@core'
import { SFSchema, SFUISchema, SFComponent } from '@delon/form'
import { _HttpClient, ALAIN_I18N_TOKEN } from '@delon/theme'
import { NzDrawerRef } from 'ng-zorro-antd/drawer'
import { NzMessageService } from 'ng-zorro-antd/message'

@Component({
  selector: 'app.xiao.xing',
  template: `
    <iframe
      src="https://xiaoxing.meinenghua.com/b/djFEsnvGgZl6d0Jl7nhcD?source=share_web"
      class="Iframe"
      width="100%"
      [height]="record.height"
      style="padding: 0"
      scrolling="no"
      frameborder="0"
    >
      <p>当前浏览器不支持iframe</p>
    </iframe>
  `,
  styles: [
    `
      :host ::ng-deep {
      }
    `,
  ],
})
export class XiaoXingComponent implements OnInit, AfterViewInit {
  @ViewChild('sf') readonly sf!: SFComponent
  @Input() record: any
  iframeHeight = '730px'
  schema: SFSchema = {
    properties: {},
    required: [],
  }
  ui: SFUISchema = {
    '*': {
      spanLabelFixed: 150,
      grid: { span: 24 },
    },
  }

  constructor(
    private ref: NzDrawerRef,
    private http: _HttpClient,
    private message: NzMessageService,
    @Inject(ALAIN_I18N_TOKEN) protected i18n: I18NService,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    new Promise((resolve) => {
      resolve(1)
    }).then(() => {
      this.iframeHeight = `${document.body.clientHeight - 110}px`
    })
  }

  ok(): void {}

  cancel(): void {
    this.ref.close()
  }
}
